var api = require("!../../../../../../shared/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../shared/node_modules/css-loader/dist/cjs.js??ref--4-1!../../../../../../shared/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../shared/node_modules/postcss-loader/src/index.js??ref--4-2!../../../../../../shared/node_modules/vue-loader/lib/index.js??vue-loader-options!./VVideoEdit.vue?vue&type=style&index=0&id=7ea9454f&scoped=true&lang=css&");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};